import React from 'react';
import { withTheme } from 'glamorous';
import Dropdown from 'react-toolbox/lib/dropdown';
import styles from './DropDownList.css';

// eslint-disable-next-line
export const DropDownList = ({
  options,
  error,
  color,
  theme: { colors },
  ...restProps
}) => {
  const className = Object.keys(colors).find(key => colors[key] === color);
  const source = options.sort((a, b) => a.order - b.order).map(opt => ({
    value: opt.text,
    label: opt.text,
  }));

  return (
    <Dropdown
      className={styles[className]}
      auto
      source={source}
      theme={styles}
      color={color}
      {...restProps}
    />
  );
};

export default withTheme(DropDownList);



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/DropDownList/index.js